export default __webpack_public_path__ + "static/media/guideline_1.5d2b8d3f.svg";